import * as React from 'react';

export const CELL_SEP = <>&#x200b;</>;
